import React from "react";
import Select from "src/components/Select";
import { Control, FieldValues } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import { AuditItemSituation } from "../interface";

export interface ISelectAuditSituation{
    name: string;
    control: Control<FieldValues>;
    defaultValue?: any;
}

const SelectAuditSituation: React.FC<ISelectAuditSituation> = ({
	name,
	control,
	defaultValue
}) => {
	const { translate } = useTranslation();

	const situationOptions = [
		{
			value: AuditItemSituation.CONFORM.toString(),
			label: translate("Conforme")
		},
		{
			value: AuditItemSituation.NOT_CONFORM.toString(),
			label: translate("Não Conforme")
		},
		{
			value: AuditItemSituation.OPPORTUNITY_IMPROVEMENT.toString(),
			label: translate("Oportunidade de Melhoria")
		},
		{
			value: AuditItemSituation.OBSERVATION.toString(),
			label: translate("Observação")
		}
	];

	return (
		<>
			<Select 
				control={control}
				name={name} 
				options={situationOptions} 
				label={translate("Situação")}
				defaultValue={String(defaultValue)}
				submit="value"
			/>
		</>
	);
};


export default SelectAuditSituation;
